export const getFields = (
  category,
  newVal,
  optionsAfectados = [],
  optionsVinculados = [],
  optionsRobados = [],
  optionsTipoMoneda = [],
  readonly = false
) => {
  const fieldsByCategory = {
    afectacionPatrimonial: {
      transferencia: [
        {
          type: "inputMask",
          mask: "99/99/9999",
          name: "fecha",
          label: "Fecha",
          placeholder: "Ingresa la fecha",
          cols: 4,
          validation: { required: true, isDate: true },
        },
        {
          type: "input",
          name: "tipo",
          label: "Tipo de Transferencia",
          placeholder: "Ingresa el tipo de transferencia",
          cols: 4,
          validation: { required: true },
          hidden: true,
          value: newVal,
        },
        {
          type: "input",
          name: "monto",
          label: "Monto",
          placeholder: "Ingresa el monto",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "1" },
        },
        {
          type: "dropdown",
          placeholder: "Seleccione una moneda",
          name: "tipoMoneda",
          label: "Moneda",
          options: optionsTipoMoneda,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "input",
          name: "identificadorOrigen",
          label: "Cbu/Alias Origen",
          placeholder: "Ingresa el identificador de origen",
          cols: 4,
          validation: { required: true, min: "3" },
        },
        {
          type: "input",
          name: "identificadorDestino",
          label: "Cbu/Alias Destino",
          placeholder: "Ingresa el identificador de destino",
          cols: 4,
          validation: { required: true, min: "3" },
        },
        {
          type: "input",
          name: "entidadBancaria",
          label: "Entidad Bancaria",
          placeholder: "Ingresa la entidad bancaria",
          cols: 4,
          validation: { required: true, min: "3" },
        },
        {
          type: "dropdown",
          name: "afectadoId",
          label: "Afectado",
          placeholder: "Elija un Afectado",
          options: optionsAfectados,
          cols: 6,
          validation: { required: true },
        },
        {
          type: "dropdown",
          name: "vinculadoId",
          label: "Vinculado",
          placeholder: "Elija un Vinculado",
          options: optionsVinculados,
          cols: 6,
          validation: { required: true },
        },
        {
          type: "dropdown",
          name: "esPropietario",
          label: "Propietario de Cuenta",
          placeholder: "¿Es propietario de Cuenta?",
          options: [
            { nombre: "Sí", value: 1 },
            { nombre: "No", value: 0 },
          ],
          cols: 6,
          validation: { required: true },
          conditional: {
            condition: (value) => value === 0,
            fields: [
              {
                type: "input",
                name: "dni",
                label: "DNI",
                placeholder: "Ingresa el DNI",
                cols: 4,
                validation: { required: true, min: 5, isNumeric: true },
              },
              {
                type: "input",
                name: "nombreCompleto",
                label: "Nombre Completo",
                placeholder: "Ingresa el nombre completo",
                cols: 6,
                validation: { required: true, min: 5 },
              },
            ],
          },
        },
        {
          type: "textarea",
          name: "observaciones",
          label: "Observaciones",
          placeholder: "Observaciones",
          cols: 12,
          rows: 3,
          validation: { required: true, min: "5" },
        },
      ],

      credito: [
        {
          type: "inputMask",
          mask: "99/99/9999",
          name: "fecha",
          label: "Fecha",
          placeholder: "Ingresa la fecha",
          cols: 4,
          validation: { required: true, isDate: true },
        },
        {
          type: "input",
          name: "tipo",
          label: "Tipo",
          cols: 4,
          validation: { required: true },
          value: newVal,
          hidden: true,
        },
        {
          type: "input",
          name: "monto",
          label: "Monto",
          placeholder: "Ingresa el monto",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "1" },
        },
        {
          type: "dropdown",
          placeholder: "Seleccione una moneda",
          name: "tipoMoneda",
          label: "Moneda",
          options: optionsTipoMoneda,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "input",
          name: "NroTarjeta",
          label: "Nro de Tarjeta de Crédito",
          placeholder: "Nro de Tarjeta de Crédito",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "5" },
        },
        {
          type: "input",
          name: "entidadBancaria",
          label: "Entidad Bancaria",
          placeholder: "Ingresa la entidad bancaria",
          cols: 4,
          validation: { required: true, min: "3" },
        },
        {
          type: "textarea",
          name: "observaciones",
          label: "Observaciones",
          placeholder: "Observaciones",
          cols: 12,
          rows: 3,
          validation: { required: true, min: "5" },
        },
      ],

      debito: [
        {
          type: "inputMask",
          mask: "99/99/9999",
          name: "fecha",
          label: "Fecha",
          placeholder: "Ingresa la fecha",
          cols: 4,
          validation: { required: true, isDate: true },
        },
        {
          type: "input",
          name: "tipo",
          label: "Tipo",
          cols: 4,
          validation: { required: true },
          value: newVal,
          hidden: true,
        },
        {
          type: "input",
          name: "monto",
          label: "Monto",
          placeholder: "Ingresa el monto",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "1" },
        },
        {
          type: "dropdown",
          placeholder: "Seleccione una moneda",
          name: "tipoMoneda",
          label: "Moneda",
          options: optionsTipoMoneda,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "input",
          name: "NroTarjeta",
          label: "Nro de Tarjeta de Débito",
          placeholder: "Nro de Tarjeta de Débito",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "5" },
        },
        {
          type: "input",
          name: "entidadBancaria",
          label: "Entidad Bancaria",
          placeholder: "Ingresa la entidad bancaria",
          cols: 4,
          validation: { required: true, min: "3" },
        },
        {
          type: "textarea",
          name: "observaciones",
          label: "Observaciones",
          placeholder: "Observaciones",
          cols: 12,
          rows: 3,
          validation: { required: true, min: "5" },
        },
      ],

      permuta: [
        {
          type: "inputMask",
          mask: "99/99/9999",
          name: "fecha",
          label: "Fecha",
          placeholder: "Ingresa la fecha",
          cols: 4,
          validation: { required: true, isDate: true },
        },
        {
          type: "input",
          name: "tipo",
          label: "Tipo de Transferencia",
          cols: 4,
          validation: { required: true },
          hidden: true,
          value: newVal,
        },
        {
          type: "input",
          name: "monto",
          label: "Monto",
          placeholder: "Ingresa el monto",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "1" },
        },
        {
          type: "dropdown",
          placeholder: "Seleccione una moneda",
          name: "tipoMoneda",
          label: "Moneda",
          options: optionsTipoMoneda,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "dropdown",
          name: "bienEntregado",
          label: "Bien Entregado",
          placeholder: "Elija un bien entregado",
          options: optionsRobados,
          cols: 4,
          validation: { required: true, unique: true },
        },
        {
          type: "dropdown",
          name: "vinculadoId",
          label: "Vinculado ",
          placeholder: "Elija un Vinculado",
          options: optionsVinculados,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "textarea",
          name: "observaciones",
          label: "Observaciones",
          placeholder: "Observaciones",
          cols: 12,
          rows: 3,
          validation: { required: true, min: "5" },
        },
      ],

      efectivo: [
        {
          type: "inputMask",
          mask: "99/99/9999",
          name: "fecha",
          label: "Fecha",
          placeholder: "Ingresa la fecha",
          cols: 4,
          validation: { required: true, isDate: true },
        },
        {
          type: "input",
          name: "tipo",
          label: "Tipo de Transferencia",
          cols: 4,
          validation: { required: true },
          hidden: true,
          value: newVal,
        },
        {
          type: "input",
          name: "monto",
          label: "Monto",
          placeholder: "Ingresa el monto",
          cols: 4,
          validation: { required: true, isNumeric: true, min: "1" },
        },
        {
          type: "dropdown",
          placeholder: "Seleccione una moneda",
          name: "tipoMoneda",
          label: "Moneda",
          options: optionsTipoMoneda,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "dropdown",
          name: "vinculadoId",
          label: "Vinculado ",
          placeholder: "Elija un Vinculado",
          options: optionsVinculados,
          cols: 4,
          validation: { required: true },
        },
        {
          type: "textarea",
          name: "observaciones",
          label: "Observaciones",
          placeholder: "Observaciones",
          cols: 12,
          rows: 3,
          validation: { required: true, min: "5" },
        },
      ],

      cripto: [
        {
          type: "inputMask",
          mask: "99/99/9999",
          name: "fecha",
          label: "Fecha",
          placeholder: "Ingresa la fecha",
          cols: 4,
          validation: { required: true, isDate: true },
        },
        {
          type: "input",
          name: "tipo",
          label: "Tipo de Transferencia",
          placeholder: "Ingresa el tipo de transferencia",
          cols: 4,
          validation: { required: true },
          hidden: true,
          value: newVal,
        },
        {
          type: "input",
          name: "monto",
          label: "Monto",
          placeholder: "Ingresa el monto",
          cols: 3,
          validation: { required: true, isNumeric: true, min: "1" },
        },
        {
          type: "dropdown",
          placeholder: "Seleccione una criptomeneda",
          name: "tipoMoneda",
          label: "Criptomoneda",
          options: optionsTipoMoneda,
          cols: 5,
          validation: { required: true },
        },
        {
          type: "input",
          name: "identificadorOrigen",
          label: "Identificador Cripto Origen",
          placeholder: "Ingresa la dirección cripto origen",
          cols: 6,
          validation: { required: true, min: "3" },
        },
        {
          type: "input",
          name: "identificadorDestino",
          label: "Identificador Cripto Destino",
          placeholder: "Ingresa la dirección cripto destino",
          cols: 6,
          validation: { required: true, min: "3" },
        },
        {
          type: "dropdown",
          name: "afectadoId",
          label: "Afectado",
          placeholder: "Elija un Afectado",
          options: optionsAfectados,
          cols: 6,
          validation: { required: true },
        },
        {
          type: "dropdown",
          name: "vinculadoId",
          label: "Vinculado ",
          placeholder: "Elija un Vinculado",
          options: optionsVinculados,
          cols: 6,
          validation: { required: true },
        },
        {
          type: "dropdown",
          name: "esPropietario",
          label: "Propietario de Cuenta",
          placeholder: "¿Es propietario de Cuenta?",
          options: [
            { nombre: "Sí", value: 1 },
            { nombre: "No", value: 0 },
          ],
          cols: 6,
          validation: { required: true },
          conditional: {
            condition: (value) => value === 0,
            fields: [
              {
                type: "input",
                name: "dni",
                label: "DNI",
                placeholder: "Ingresa el DNI",
                cols: 4,
                validation: { required: true, min: 5 },
                validation: { required: true, isNumeric: true, min: 5 },
              },
              {
                type: "input",
                name: "nombreCompleto",
                label: "Nombre Completo",
                placeholder: "Ingresa el nombre completo",
                cols: 6,
                validation: { required: true, min: 5 },
              },
            ],
          },
        },
        {
          type: "textarea",
          name: "observaciones",
          label: "Observaciones",
          placeholder: "Observaciones",
          cols: 12,
          rows: 3,
          validation: { required: true, min: 5 },
        },
      ],
    },
  };
  if (!fieldsByCategory[category]) {
    console.error(`La categoría ${category} no existe.`);
    return [];
  }
  if (!fieldsByCategory[category][newVal]) {
    console.error(`El tipo ${newVal} no existe en la categoría ${category}.`);
    return [];
  }
  return applyReadonly(fieldsByCategory[category][newVal], readonly);
};

const applyReadonly = (fields, readonly) => {
  if (!readonly) return fields;

  return fields.map((field) => {
    const cloned = { ...field };

    if (["dropdown", "input", "inputMask", "textarea"].includes(field.type)) {
      cloned.disabled = true;
    }

    if (field.conditional?.fields?.length) {
      cloned.conditional.fields = field.conditional.fields.map((f) => ({
        ...f,
        disabled: true,
      }));
    }

    return cloned;
  });
};
